<section class="section why-us overflow-hidden">
  <div class="shape-wrapper">
    <div class="absolute shape-background top right"></div>
  </div>

  <div class="container">
    <div class="section-heading text-center">
      <h2 class="bold">Why DashCore</h2>
      <p class="lead text-secondary">
        Our mission is to provide you with an all-in-one template so you don't
        have to look aside in order to get what you need
      </p>
    </div>

    <div class="row gap-y">
      <div class="col-md-5">
        <ul class="list-unstyled why-icon-list">
          <li class="list-item" *ngFor="let feature of features">
            <div class="media">
              <div
                class="rounded-circle bg-{{ feature.color }} shadow-{{
                  feature.color
                }} text-contrast p-3 icon-xl d-flex align-items-center justify-content-center mr-3"
              >
                <dc-feather
                  [name]="feature.icon"
                  [iconClass]="feature.icon"
                ></dc-feather>
              </div>

              <div class="media-body">
                <h5 class="bold">{{ feature.name }}</h5>
                <p class="my-0">{{ feature.description }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="col-md-7">
        <figure data-aos="fade-left">
          <img
            src="assets/img/automate-social/build.svg"
            class="img-responsive"
            alt=""
          />
        </figure>
      </div>
    </div>

    <div class="mt-5 text-center">
      <a [routerLink]="['/auth/register']" class="btn btn-primary btn-rounded"
        >Register for a free demo</a
      >
      <p class="small">- or -</p>
      <a [routerLink]="['/contact']" class="btn btn-link">Contact us</a>
    </div>
  </div>
</section>
